import React from 'react';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BackButton } from 'components/Buttons';
import Content from 'components/Content';

const NotFound = () => {
	return (
		<div style={{ display: 'flex', width: '100%' }}>
			<Content>
				<Grid
					container
					direction="row"
					justifyContent="space-between"
					alignItems="flex-start"
				>
					<BackButton />
				</Grid>
				<h1>Page Not Found</h1>
				<h1 style={{ fontSize: '7rem', color: 'red' }}>
					<FontAwesomeIcon icon="exclamation-triangle" />
				</h1>
				<h4>404 error</h4>
				<h3>Page you are looking for does not exist</h3>
			</Content>
		</div>
	);
};

export default NotFound;
